document.addEventListener("DOMContentLoaded", function () {

    const sliders = document.querySelectorAll(
       ".Products__lists, .catgSlider"
    );

    sliders.forEach((slider) => {

        /*
        |--------------------------------------------------------------------------
        | Slider Settings
        |--------------------------------------------------------------------------
        */

        const slidesMobile =
            parseFloat(slider.dataset.slidesMobile) || 2;

        const slidesTablet =
            parseFloat(slider.dataset.slidesTablet) || 3;

        const slidesDesktop =
            parseFloat(slider.dataset.slidesDesktop) || 4;


        const spaceMobile =
            parseInt(slider.dataset.spaceMobile) || 10;

        const spaceTablet =
            parseInt(slider.dataset.spaceTablet) || 15;

        const spaceDesktop =
            parseInt(slider.dataset.spaceDesktop) || 20;


        const showArrows =
            slider.dataset.showArrows === "true";

        const showPagination =
            slider.dataset.showPagination === "true";


        const paginationType =
            slider.dataset.paginationType || "bullets";


        const sliderSpeed =
            parseInt(slider.dataset.sliderSpeed) || 1000;


        const sliderEffect =
            slider.dataset.sliderEffect || "slide";


        const autoplayEnabled =
            slider.dataset.autoplay === "true";


        const autoplayDelay =
            parseInt(slider.dataset.autoplayDelay) || 2500;


        /*
        |--------------------------------------------------------------------------
        | Find elements ONLY inside this slider section
        |--------------------------------------------------------------------------
        */

        const sliderContainer = slider.parentElement;


        const prevArrow =
            sliderContainer.querySelector(".swiper-button-prev");


        const nextArrow =
            sliderContainer.querySelector(".swiper-button-next");


        const pagination =
            sliderContainer.querySelector(".swiper-pagination");


        /*
        |--------------------------------------------------------------------------
        | Swiper Options
        |--------------------------------------------------------------------------
        */

        const swiperOptions = {

            direction: "horizontal",

            speed: sliderSpeed,

            effect: sliderEffect,

            watchOverflow: true,

            breakpoints: {

                280: {
                    slidesPerView: slidesMobile,
                    spaceBetween: spaceMobile
                },

                576: {
                    slidesPerView: slidesTablet,
                    spaceBetween: spaceTablet
                },

                1025: {
                    slidesPerView: slidesDesktop,
                    spaceBetween: spaceDesktop
                }

            }

        };


        /*
        |--------------------------------------------------------------------------
        | Navigation
        |--------------------------------------------------------------------------
        */

        if (
            showArrows &&
            prevArrow &&
            nextArrow
        ) {

            swiperOptions.navigation = {

                nextEl: nextArrow,

                prevEl: prevArrow

            };

        }


        /*
        |--------------------------------------------------------------------------
        | Pagination
        |--------------------------------------------------------------------------
        */

        if (
            showPagination &&
            pagination
        ) {

            swiperOptions.pagination = {

                el: pagination,

                clickable: true,

                type: paginationType

            };

        }


        /*
        |--------------------------------------------------------------------------
        | Autoplay
        |--------------------------------------------------------------------------
        */

        // if (autoplayEnabled) {

        //     swiperOptions.autoplay = {

        //         delay: autoplayDelay,

        //         disableOnInteraction: false

        //     };

        // }


        /*
        |--------------------------------------------------------------------------
        | Initialize
        |--------------------------------------------------------------------------
        */

        new Swiper(
            slider,
            swiperOptions
        );

    });

});